const FEDAPAY_SCRIPT_URL = 'https://cdn.fedapay.com/checkout.js?v=1.1.7';

/**
 * Charge le script FedaPay s'il n'est pas déjà présent
 */
function loadFedaPayScript() {
  return new Promise((resolve, reject) => {
    if (window.FedaPay) {
      resolve(window.FedaPay);
      return;
    }
    const script = document.createElement('script');
    script.src = FEDAPAY_SCRIPT_URL;
    script.onload = () => resolve(window.FedaPay);
    script.onerror = () => reject(new Error('Impossible de charger le script FedaPay'));
    document.head.appendChild(script);
  });
}

/**
 * Adaptateur FedaPay
 * @param {object} params - { amount, currency, description, customer, config }
 */
export async function processFedapay({ amount, currency, description, customer, config }) {
  console.log('🚀 Initializing FedaPay Checkout...', { amount, currency, description });

  try {
    const FedaPay = await loadFedaPayScript();
    
    return new Promise((resolve) => {
      const widget = FedaPay.init({
        public_key: config.publicKey,
        environment: config.environment || 'sandbox',
        transaction: {
          amount: amount,
          description: description,
          // currency: {
          //   iso: currency
          // }
        },
        customer: {
          email: customer.email,
          lastname: customer.fullName,
          // phone_number: {
          //   number: customer.phone
          // }
        },
        
        onComplete: (resp) => {
          console.log("🚀 ~ processFedapay ~ resp:", resp)
          const FedaPay = window.FedaPay;
          if (resp.reason === FedaPay.CHECKOUT_COMPLETED) {
            resolve({
              success: true,
              transactionId: resp.transaction.id,
              provider: 'fedapay',
              data: resp.transaction
            });
          } else {
            resolve({
              success: false,
              error: 'Le processus de paiement a été interrompu ou a échoué.',
              reason: resp.reason
            });
          }
        }
      });

      widget.open();
    });
  } catch (error) {
    console.error('FedaPay Load Error:', error);
    return { success: false, error: 'Erreur technique lors du chargement de FedaPay.' };
  }
}
